<script setup lang="ts">
import type { LocationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  location: LocationCollectionItem
}>()

const {
  close,
  address,
  companyName,
  articleRoute,
} = useLocation(props.location)
</script>

<template>
  <div>
    <div class="dark w-[20rem] xl:w-[22rem] 2xl:w-[24rem] bg-primary-800 border border-primary-700 rounded-lg shadow-lg shadow-primary-950/50">
      <header class="flex items-center p-2 border-b border-primary-700">
        <span class="text-[.8rem] font-bold text-primary-200 font-heading">{{ props.location.title }}</span>
        <div class="ml-auto">
          <UButton variant="ghost" icon="mdi:close" aria-label="Sluiten" @click="close" />
        </div>
      </header>
      <div class="p-2 grid gap-2">
        <div class="aspect-video">
          <LazyVideoPreview :inline="true" :url="props.location.video" class="border border-primary-700 rounded overflow-hidden" />
        </div>
        <div v-if="address">
          {{ address }}
        </div>
        <div v-if="companyName">
          {{ companyName }}
        </div>
      </div>
      <div class="p-2 border-t border-primary-700">
        <UButton :to="articleRoute" block>
          Lees meer
        </UButton>
      </div>
    </div>
    <div class="justify-items-center">
      <div
        class="h-0 w-0 border-x-[1rem] relative top-[-1px] border-x-transparent border-t-[.8rem] border-t-primary-800"
      />
    </div>
  </div>
</template>
